/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Comms/Filter/Error"
  
}) {
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={8}
 marginLeft={30}
 text="Can't load phone numbers filter"
/>
{children}
</React.Fragment>)
}